

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferInterfaceButtonClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

